import { Button } from 'pctComponents/atoms';
import './style.scss';
import CloseIcon from '@material-ui/icons/Close';

import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { connect } from 'react-redux';
import { updateChangeSupportAccess } from 'actions';
import {  exitSupportAccess, withRouterAndRef } from 'services/utils';


function SupportAccess({ accessSupportData, resetHeader = () => {}, updateChangeSupport }) {
    
    const history = useHistory();

    const {
        supportAccessUser: { name },
    } = accessSupportData;

    useEffect(() => {
        document.body.classList.add('support-access-container');
    }, []);

    useEffect(() => {
        resetHeader();
    }, [resetHeader]);

    return (
        <div className="supportAccessHeader">
            <span>Você está fazendo acesso suporte para</span> <span>- {name}</span>
            <Button
                ico={CloseIcon}
                text="Sair"
                callEvent={() => {
                    exitSupportAccess({
                        handleExitSupportAccess: () => {
                            updateChangeSupport(); /// função serva para atualizar o menu Principal
                            history.push('/');
                        },
                    });
                }}
            />
        </div>
    );
}


const mapDispatchToProps = (dispatch) => ({
    updateChangeSupport: (item) => dispatch(updateChangeSupportAccess(item)),
});

export default withRouterAndRef(connect(null, mapDispatchToProps)(SupportAccess));

// export default SupportAccess;
